import { Box, Chip, InputLabel, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { LightTooltip } from "components/PimDashboard/CommonComponents/CustomToolTip/CustomToolTip";
import { attrGroupLinkedTables } from "components/PimDashboard/data";
import { PimDashboardState } from "context/PimDashboardContext";
import { muiCustomScrollbar, styleImageColumn } from "data/globalData";
import moment from "moment";
const StyleProductBox = ({ data, imgUrl, imageOnly = false, imgWidth = 105, imgHeight = 130 }) => {
	const { allAttributes } = PimDashboardState();
	return (
		<Box width="100%" display="flex" alignItems="center" justifyContent="space-between">
			<img
				style={{
					width: `${imgWidth}px`,
					height: `${imgHeight}px`,
					objectFit: "cover",
					objectPosition: "50% 0%",
					borderRadius: 2,
				}}
				src={imgUrl ?? ""}
			/>
			{!imageOnly && (
				<Stack pl={1} pr={1} rowGap="4px" flexGrow={1}>
					{/* <Typography variant="h6" width="100%" fontSize={20}>
					{data?.style_name ?? "Style Name"}
				</Typography>
				{/* <Typography variant="body1" fontSize={12} fontWeight={500} pt={0}>
					{data.color}-{data.pallette}
				</Typography> 
				<Box display="flex" columnGap={1} alignItems="center">
					<Chip label={data?.category ?? "SHIRT"} size="small" />
					<Typography variant="h6" fontSize={16}>
						{data?.sub_category ?? "SOLID"}
					</Typography>
				</Box> */}
					{allAttributes
						?.filter((row) => row?.linked_table === attrGroupLinkedTables.color.key)
						.map((details) => (
							<Stack
								width={"100%"}
								spacing={0}
								key={details?.name}
								overflow="hidden"
								direction="row"
								border={`1px solid white`}
								boxSizing="border-box">
								<LightTooltip title={details?.name} placement="bottom-start" arrow>
									<InputLabel
										component="caption"
										sx={{
											width: "42%",
											borderRadius: "1px 0px 0px 1px",
											p: "6px 3px 6px 3px",
											background: "#000",
											overflow: "hidden",
											color: grey[100],
											fontSize: "13px",
										}}>
										{details?.name}
									</InputLabel>
								</LightTooltip>
								<Typography
									variant="body2"
									sx={{
										width: "58%",
										p: "6px 3px 6px 3px",
										background: grey[200],
										fontWeight: 400,
										overflow: "hidden",
										borderRadius: " 0px 1px 1px 0px",
									}}>
									{data?.[details?.key]}
								</Typography>
							</Stack>
						))}
				</Stack>
			)}
		</Box>
	);
};

const StyleDetailsGrid = ({
	data,
	sx,
	fieldWidth,
	groupHeight = "22vh",
	displayGroups = [],
	files,
	onFileClick = () => {},
	hideFiles = false,
}) => {
	const { allAttributes } = PimDashboardState();
	let imgWidth = 105;
	let imgHeight = 130;
	return (
		<Box sx={sx ? sx : { width: "25%" }} boxSizing="border-box">
			<Box display="flex" width="100%">
				<StyleProductBox
					data={data}
					imgUrl={data?.[styleImageColumn.key]}
					imageOnly={!displayGroups?.includes("color")}
					imgWidth={imgWidth}
					imgHeight={imgHeight}
				/>
				<Stack width="100%" maxHeight={imgHeight + 10} sx={{ overflowY: "scroll", display: hideFiles ? "none" : "block" }}>
					<Typography>Files</Typography>
					{files?.map((row) => {
						return (
							<Box onClick={() => onFileClick(row)} width="100%" sx={{ textDecoration: "underline", cursor: "pointer" }}>
								<span style={{ fontSize: "13px" }}>
									{row?.file_type}({row?.effective_date && moment(row?.effective_date).format("DD-MM-YYYY")})
								</span>
							</Box>
						);
					})}
				</Stack>
			</Box>

			<Typography variant="h6" fontSize={14} pt={1}>
				Style Attributes
			</Typography>
			<Box
				display="flex"
				flexWrap="wrap"
				maxHeight={displayGroups?.includes("designer_suggestions") ? groupHeight : "100%"}
				sx={{ overflowY: "scroll", ...muiCustomScrollbar }}>
				{allAttributes
					?.filter((row) => row?.linked_table === attrGroupLinkedTables.style.key)
					.map((details) => (
						<Stack
							width={fieldWidth ? fieldWidth : "100%"}
							spacing={0}
							key={details?.name}
							overflow="hidden"
							direction="row"
							border={`1px solid white`}
							boxSizing="border-box">
							<LightTooltip title={details?.name} placement="bottom-start" arrow>
								<InputLabel
									component="caption"
									sx={{
										width: "42%",
										borderRadius: "1px 0px 0px 1px",
										p: "4px 3px 4px 3px",
										background: "#000",
										overflow: "hidden",
										color: grey[100],
										fontSize: "14px",
									}}>
									{details?.name}
								</InputLabel>
							</LightTooltip>
							<Typography
								variant="body1"
								sx={{
									width: "58%",
									p: "4px 3px 4px 3px",
									background: grey[200],
									fontWeight: 400,
									overflow: "hidden",
									borderRadius: " 0px 1px 1px 0px",
									textAlign: "center",
								}}>
								{data?.[details?.key]}
							</Typography>
						</Stack>
					))}
			</Box>
			{displayGroups?.includes("designer_suggestions") && (
				<>
					<Typography variant="h6" fontSize={14} pt={1}>
						Designer Suggestions
					</Typography>
					<Box
						pt="5px"
						display="flex"
						flexWrap="wrap"
						maxHeight={groupHeight}
						sx={{ overflowY: "scroll", ...muiCustomScrollbar }}>
						{allAttributes
							?.filter((row) => row?.group_id === "suggestions")
							?.map((details) => (
								<Stack
									width={fieldWidth ? fieldWidth : "100%"}
									spacing={0}
									key={details?.name}
									overflow="hidden"
									direction="row"
									border={`1px solid white`}
									boxSizing="border-box">
									<LightTooltip title={details?.name} placement="bottom-start" arrow>
										<InputLabel
											component="caption"
											sx={{
												width: "40%",
												borderRadius: "1px 0px 0px 1px",
												p: "4px 3px 4px 3px",
												background: "#000",
												overflow: "hidden",
												color: grey[100],
												fontSize: "14px",
											}}>
											{details?.name}
										</InputLabel>
									</LightTooltip>
									<Typography
										variant="body1"
										sx={{
											width: "55%",
											p: "4px 3px 4px 3px",
											background: grey[200],
											fontWeight: 400,
											overflow: "hidden",
											borderRadius: " 0px 1px 1px 0px",
											textAlign: "center",
										}}>
										{data?.[details?.key]}
									</Typography>
								</Stack>
							))}
					</Box>
				</>
			)}
		</Box>
	);
};
export default StyleDetailsGrid;
